import underwriter from "apis/underwriter";
import { WebApiRequest, WebApiReduxRequest, HTTP_GET, HTTP_PUT, HTTP_DELETE } from "tools/webservice";
import {
  REQUEST_UNDERWRITERS_FOR_USER,
  RECEIVE_UNDERWRITERS_FOR_USER,
  ERROR_UNDERWRITERS_FOR_USER,
  REQUEST_ACTIVE_UNDERWRITERS_FOR_USER,
  RECEIVE_ACTIVE_UNDERWRITERS_FOR_USER,
  ERROR_ACTIVE_UNDERWRITERS_FOR_USER,
} from "typeConstants";

export const underwriterSearchByMajorCompanyCode = (majorCompanyCode, successCallback, mountedRef) =>
  WebApiRequest({
    method: HTTP_GET,
    endpoint: underwriter.underwriterListByMajorCompanyCode(majorCompanyCode),
    successCallback,
    mountedRef,
  });
export const getAllUnderwritersForUser = (successCallback, mountedRef) =>
  WebApiRequest({
    method: HTTP_GET,
    endpoint: underwriter.allUnderWritersForCurrentUser(),
    successCallback,
    mountedRef,
  });
export const getAllActiveUnderwritersForUser = (successCallback, mountedRef) =>
  WebApiRequest({
    method: HTTP_GET,
    endpoint: underwriter.allActiveUnderWritersForCurrentUser(),
    successCallback,
    mountedRef,
  });
export const assignCasesToUnderwriter = (payload, successCallback, errorCallback, mountedRef) =>
  WebApiRequest({
    method: HTTP_PUT,
    endpoint: underwriter.assignCases(),
    successCallback,
    errorCallback,
    mountedRef,
    payload,
  });
export const unassignCasesToUnderwriter = (payload, successCallback, errorCallback, mountedRef) =>
  WebApiRequest({
    method: HTTP_DELETE,
    endpoint: underwriter.assignCases(),
    successCallback,
    errorCallback,
    mountedRef,
    payload,
  });
export const getAllUnderwritersForUserRedux = () => {
  return WebApiReduxRequest(
    REQUEST_UNDERWRITERS_FOR_USER,
    RECEIVE_UNDERWRITERS_FOR_USER,
    ERROR_UNDERWRITERS_FOR_USER,
    HTTP_GET,
    underwriter.allUnderWritersForCurrentUser()
  );
};
export const getAllActiveUnderwritersForUserRedux = () => {
  return WebApiReduxRequest(
    REQUEST_ACTIVE_UNDERWRITERS_FOR_USER,
    RECEIVE_ACTIVE_UNDERWRITERS_FOR_USER,
    ERROR_ACTIVE_UNDERWRITERS_FOR_USER,
    HTTP_GET,
    underwriter.allActiveUnderWritersForCurrentUser()
  );
};
export const getNextCase = (successCallback, mountedRef) =>
  WebApiRequest({
    method: HTTP_GET,
    endpoint: underwriter.getNext(),
    successCallback,
    mountedRef,
  });

export const updateUnderwriter = (underwriterId, payload, successCallback, mountedRef) =>
  WebApiRequest({
    method: HTTP_PUT,
    endpoint: underwriter.updateUnderwriter(underwriterId),
    payload,
    successCallback,
    mountedRef,
  });
